import { render, staticRenderFns } from "./WidgetSkilledWorkerDependantVisa.vue?vue&type=template&id=2606317a&scoped=true&lang=pug"
import script from "./WidgetSkilledWorkerDependantVisa.vue?vue&type=script&lang=ts"
export * from "./WidgetSkilledWorkerDependantVisa.vue?vue&type=script&lang=ts"
import style0 from "./WidgetSkilledWorkerDependantVisa.vue?vue&type=style&index=0&id=2606317a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606317a",
  null
  
)

export default component.exports